import React from 'react';

import {
    Container,
    ContainerRow,
    CloseButton,
    TextExit,
    ExitButton
} from './styles';

export const ModalSair = ({ handleCloseModalLogout, onLogoutHandler }) => {
    return (
        <Container>
            <ContainerRow>
                <TextExit>Sair da aplicação?</TextExit>
                <CloseButton
                    type="button"
                    onClick={() => {
                        handleCloseModalLogout();
                    }}
                >
                    X
                </CloseButton>
            </ContainerRow>
            <hr />

            <ExitButton onClick={() => onLogoutHandler()}>Sair</ExitButton>
        </Container>
    );
};
